import { render, staticRenderFns } from "./addbaojia.vue?vue&type=template&id=f8c94d08&scoped=true"
import script from "./addbaojia.vue?vue&type=script&lang=js"
export * from "./addbaojia.vue?vue&type=script&lang=js"
import style0 from "./addbaojia.vue?vue&type=style&index=0&id=f8c94d08&prod&lang=scss"
import style1 from "./addbaojia.vue?vue&type=style&index=1&id=f8c94d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c94d08",
  null
  
)

export default component.exports